// components/templates/sections/LocationSection.tsx
'use client';
import Image from 'next/image';
import Link from 'next/link';
import { useDesign } from '@/context/DesignContext';

interface LocationSectionProps {
  leftImage?: string;
  rightImage?: string;
  subtitle: string;
  title: string;
  description: string;
  phoneLabel: string;
  phone: string;
  infoLabel: string;
  address: string;
  email: string;
  hours: string;
  buttonText?: string;
  buttonLink?: string;
  design?: any;
}

export default function LocationSection({
  leftImage,
  rightImage,
  subtitle,
  title,
  description,
  phoneLabel,
  phone,
  infoLabel,
  address,
  email,
  hours,
  buttonText = 'get directions',
  buttonLink = '#',
  design: propDesign,
}: LocationSectionProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;

  const primaryColor = design?.colors?.primary || '#E07A5F';
  const textColor = design?.colors?.text || '#1E1E1E';
  const bodyFont = design?.typography?.bodyFont || "'Plus Jakarta Sans', sans-serif";
  const headingFont = design?.typography?.headingFont || "'Sora', sans-serif";
  const btnStyle = design?.buttons?.outline || {
    class: 'tf-button style3',
    backgroundColor: 'transparent',
    borderColor: 'var(--primary)',
    textColor: 'var(--primary)',
    borderRadius: '30px',
    padding: '10px 25px',
  };
  const containerMaxWidth = design?.spacing?.containerMaxWidth || '1200px';

  const linkColor = primaryColor;
  const buttonStyle: React.CSSProperties = {
    backgroundColor: btnStyle.backgroundColor,
    border: btnStyle.borderColor ? `1px solid ${btnStyle.borderColor}` : 'none',
    color: btnStyle.textColor,
    padding: btnStyle.padding,
    borderRadius: btnStyle.borderRadius,
    display: 'inline-block',
    textDecoration: 'none',
  };

  return (
    <section className="location" style={{ padding: '60px 0' }}>
      <div className="container" style={{ maxWidth: containerMaxWidth, margin: '0 auto' }}>
        <div className="row" style={{ display: 'flex', alignItems: 'center' }}>
          <div className="col-xl-4 col-md-12" style={{ marginBottom: '1rem' }}>
            <div className="image left" data-aos="fade-right">
              <Image src={leftImage || '/placeholder.jpg'} alt="" width={400} height={300} style={{ width: '100%', height: 'auto', borderRadius: design?.effects?.borderRadius || '8px' }} />
            </div>
          </div>
          <div className="col-xl-4 col-md-12">
            <div className="content">
              <div className="block-text center" style={{ textAlign: 'center' }}>
                <p className="subtitle" style={{ fontFamily: headingFont, color: primaryColor }}>{subtitle}</p>
                <h3 className="title" style={{ fontFamily: headingFont, color: textColor, fontSize: '1.8rem', marginBottom: '1rem' }}>{title}</h3>
                <p className="text" style={{ fontFamily: bodyFont, color: design?.colors?.textLight, marginBottom: '1.5rem' }}>{description}</p>
                <h6 style={{ fontFamily: headingFont }}>{phoneLabel}</h6>
                <h3 className="phone" style={{ fontFamily: headingFont, color: primaryColor, marginBottom: '1rem' }}>{phone}</h3>
                <h6 style={{ fontFamily: headingFont }}>{infoLabel}</h6>
                <p className="mb-6" style={{ fontFamily: bodyFont }}><span style={{ fontWeight: 'bold' }}>Address:</span> {address}</p>
                <p className="mb-6" style={{ fontFamily: bodyFont }}><span style={{ fontWeight: 'bold' }}>Mail:</span> <a href={`mailto:${email}`} style={{ color: linkColor }}>{email}</a></p>
                <p className="mb-6" style={{ fontFamily: bodyFont }}><span style={{ fontWeight: 'bold' }}>Opening Hour:</span> {hours}</p>
                <Link href={buttonLink} className={btnStyle.class} style={buttonStyle}>{buttonText}</Link>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-md-12" data-aos="fade-left" style={{ marginBottom: '1rem' }}>
            <div className="image right">
              <Image src={rightImage || '/placeholder.jpg'} alt="" width={400} height={300} style={{ width: '100%', height: 'auto', borderRadius: design?.effects?.borderRadius || '8px' }} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}